import { render, staticRenderFns } from "./Organizer.vue?vue&type=template&id=bedcc208&scoped=true&"
import script from "./Organizer.vue?vue&type=script&lang=js&"
export * from "./Organizer.vue?vue&type=script&lang=js&"
import style0 from "./Organizer.vue?vue&type=style&index=0&id=bedcc208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedcc208",
  null
  
)

export default component.exports